import { EventsTable } from "fleet/view/incidents/events-table";
import {
  formatDate,
  formatResolvedStatus,
  formatTargetEvents,
} from "fleet/view/incidents/table-format";
import PropTypes from "prop-types";
import React from "react";
import { Notification } from "ui/notification";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";

class IncidentDetailReportPage extends React.PureComponent {
  static get propTypes() {
    return {
      reportData: PropTypes.array.isRequired,
      errorMessage: PropTypes.string,
      successMessage: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      errorMessage: "",
      successMessage: "",
    };
  }

  _renderAlerts() {
    const { reportData } = this.props;

    return reportData.map((entry) => {
      const { alert, incidents } = entry;

      return (
        <Box
          key={alert.id}
          title={`${alert.name} Email Notification`}
          className="alert"
        >
          <div className="target-event-labels">
            <div>Target Events: </div>
            {this._renderTargetEvents(alert.target_events)}
          </div>
          {this._renderIncidents(incidents)}
        </Box>
      );
    });
  }

  _renderIncidents(incidents) {
    return incidents.map((entry) => {
      const { device, events, incident } = entry;
      const createDate = formatDate(incident.create_date);
      const resolveStatus = formatResolvedStatus(incident.resolved);
      const title = incident.notification_only
        ? "Notification"
        : `${resolveStatus} Incident`;

      return (
        <Box
          key={incident.id}
          title={`${title} - ${createDate} (${device.name})`}
          className="incident"
        >
          <EventsTable events={events} />
        </Box>
      );
    });
  }

  _renderTargetEvents(targetEvents) {
    if (targetEvents.length === 0) {
      return [formatTargetEvents("*")];
    }

    return targetEvents.map(formatTargetEvents);
  }

  render() {
    const { errorMessage, successMessage } = this.props;
    const desc =
      "This report lists events that triggered device " +
      "email notifications.";

    return (
      <Page title="Email Notification Detail Report" desc={desc}>
        <Notification error={errorMessage} success={successMessage} />
        {this._renderAlerts()}
      </Page>
    );
  }
}

export { IncidentDetailReportPage };
